var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 378.323,
    height: 303.045,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 55",
    d: "M40.959 215.143S7.905 159.19 75.853 132.6s64.728-42.295 71.336-66.113 28.762-54.028 68.32-41.282 52.226 24.441 74.857 69.175 53.412 37.139 62.814 62.86 2.018 67.424-34.777 89.67-89.614-36.045-112.402-.686-62.57 24.017-90.666 21.38c-44.324-4.166-74.376-52.46-74.376-52.46z",
    fill: "#928386",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-shopping-cart",
    opacity: 0.6,
    stroke: "#5ea290",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52",
    d: "M132.123 244.709a15.876 15.876 0 009.489 20.348 16.386 16.386 0 006.126.947 15.878 15.878 0 10-15.615-21.295z",
    fill: "#5da290",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53",
    d: "M62.984 220.092a15.876 15.876 0 1020.348-9.489 15.876 15.876 0 00-20.348 9.489z",
    fill: "#5ea290",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 54",
    d: "M289.54 123.41l-33.792-12.3-63.815 104.883a17.981 17.981 0 01-21.847 7.452l-82.118-29.888a17.981 17.981 0 01-11.946-19.752l12.281-75.801 143.622 52.274",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 114",
    fill: "none",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 11",
    d: "M121.048 110.384l-24 85"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 12",
    d: "M156.048 122.384l-30 83"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 13",
    d: "M195.048 138.384l-41 77"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 14",
    d: "M81.042 134.214l132 49"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 15",
    d: "M78.297 155.384l123 46"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 19",
    fill: "none",
    stroke: "#6f8880",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M151.836 85.045l-9.5-16.454"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 20",
    fill: "none",
    stroke: "#6f8880",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M165.96 81.51l4.392-16.393"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 21",
    fill: "none",
    stroke: "#6f8880",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M178.157 90.634l14.722-8.5"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 115",
    fill: "none",
    stroke: "#6f8880",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 16",
    d: "M64.431 106.663l-7.237 51.494"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 17",
    d: "M56.584 76.275l-4.036 28.718"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 18",
    d: "M51.574 111.925l-2.088 14.854"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon weather-stars",
    d: "M2 197.334a6.037 6.037 0 004.228-1.922 6.021 6.021 0 001.742-4.3 6.217 6.217 0 005.944 6.226 6.217 6.217 0 00-5.944 6.226 5.917 5.917 0 00-1.742-4.3A6.037 6.037 0 002 197.334zm5.97-18.448a11.776 11.776 0 008.225-3.766 11.729 11.729 0 003.382-8.4 11.729 11.729 0 003.382 8.4 11.892 11.892 0 008.25 3.766 11.876 11.876 0 00-5.867 1.819 12.313 12.313 0 00-4.228 4.435 12.048 12.048 0 00-1.537 5.97 11.788 11.788 0 00-3.382-8.43 11.7 11.7 0 00-8.225-3.793zM73.511 37.928a11.776 11.776 0 008.225-3.766 11.729 11.729 0 003.382-8.4 11.729 11.729 0 003.382 8.4 11.892 11.892 0 008.25 3.766 11.876 11.876 0 00-5.867 1.819 12.313 12.313 0 00-4.228 4.434 12.048 12.048 0 00-1.537 5.97 11.788 11.788 0 00-3.382-8.43 11.7 11.7 0 00-8.225-3.793zM289.541 78.288a6.037 6.037 0 004.228-1.922 6.021 6.021 0 001.742-4.3 6.217 6.217 0 005.944 6.226 6.217 6.217 0 00-5.944 6.226 5.917 5.917 0 00-1.742-4.3 6.037 6.037 0 00-4.228-1.93zm14.477 9.147a9.152 9.152 0 008.737-9.147 9.154 9.154 0 008.712 9.147 9.154 9.154 0 00-8.712 9.147 8.824 8.824 0 00-2.537-6.329 8.976 8.976 0 00-6.2-2.817z",
    fill: "#759bd5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 22",
    fill: "none",
    stroke: "#928386",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M2 271.67h265"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 116",
    fill: "none",
    stroke: "#6f8880",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 16",
    d: "M244.898 191.579l-26.8 44.596",
    strokeWidth: 3.0016799999999995
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 17",
    d: "M230.295 189.883l-14.946 24.87",
    strokeWidth: 3.0016799999999995
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 18",
    d: "M217.538 200.859l-7.73 12.864",
    strokeWidth: 3.0016799999999995
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopBag);
export default __webpack_public_path__ + "static/media/shop-bag.efdeacd450b9826f5f9e60c4bbc6a0cc.svg";
export { ForwardRef as ReactComponent };